// Which store is this deployment for: 'rad' or 'novelty'
// Set via REACT_APP_STORE env var at build time.
export const STORE = process.env.REACT_APP_STORE || 'rad';

// Maps a base content key to the store-specific key.
// RAD uses the bare key (existing TSPM data unchanged).
// Novelty uses a 'novelty_' prefix.
export const storeKey = (key) => STORE === 'rad' ? key : `${STORE}_${key}`;
